export const NavItem = {
  bindings: {
    childPath: '<',
    icon: '<',
    path: '<',
    title: '<',
  },

  template: `
    <a class="nav-link d-flex align-items-end"
      ng-class="{ 'nav-link--active': $ctrl.state.includes($ctrl.path) }"
      ng-click="$ctrl.onClick($event, $ctrl.childPath)"
      ng-href="{{ $ctrl.state.href($ctrl.path, { '#': undefined }) }}">
      <i class="nav-item mr-3 d-none d-lg-inline {{ $ctrl.icon }}"
        ng-if="$ctrl.icon">
      </i>
      {{ $ctrl.title }}
    </a>`,

  controller($state) {
    'ngInject';

    return {
      $onInit() {
        this.state = $state;
      },

      onClick(event, path) {
        if (path) {
          event.preventDefault();
          $state.go(path);
        }
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Nav/NavItem.js